// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__I5bA1","container":"Layout_container__FnaC4"};